module.exports = __webpack_public_path__ + "static/img/icon3.85529a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feature/icon3.png
// module id = gXet
// module chunks = 1